<template>
    <div>
        <header>
            <div style="display: flex; margin-top: 5px;  font-size: calc(15vw * 100 / 1920);">
                <!-- 日期选择器 -->
                    <el-form :model="queryParams" ref="queryForm" label-width="120px">
                        <el-form-item label="开始时间" prop="startTime" >
                            <el-date-picker size="small" clearable v-model="queryParams.beginTime" type="date" value-format="yyyy-MM-dd"
                                placeholder="选择开始时间" :picker-options="startNoTime">
                            </el-date-picker>
                        </el-form-item>
                    
                        <el-form-item label="结束时间" prop="endTime">
                            <el-date-picker size="small" clearable v-model="queryParams.endTime" type="date" value-format="yyyy-MM-dd"
                                placeholder="选择结束时间" :picker-options="endNoTime">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                <!-- 其他查询 -->
                <el-form :inline="true" class="demo-form-inline" label-width="120px" >
                    <el-form-item label="提单号查询" prop="radio">
                        <el-input size="small" clearable v-model.trim="queryParams.blNo" placeholder="请输入提单号"
                            style="width: 100%;"></el-input>
                    </el-form-item>
                    <el-form-item label="委托单位查询">
                        <el-select size="small" filterable clearable v-model="queryParams.customer"
                            placeholder="请选择委托单位">
                            <el-option v-for="item in customOption" :key="item.id" :label="item.name"
                                :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注查询" >
                        <el-input size="small" clearable v-model="queryParams.note" placeholder="请输入备注"
                            style="width: 100%;"></el-input>
                    </el-form-item>
                    <el-form-item label="船名查询" >
                        <el-input size="small" clearable v-model="queryParams.vessel" placeholder="请输入船名"
                            style="width: 100%;"></el-input>
                    </el-form-item>
                    <el-form-item label="货物分类查询" >
                        <el-select size="small" filterable clearable v-model="queryParams.category"
                            placeholder="请选择货物分类">
                            <el-option v-for="item in classOption" :key="item.id" :label="item.value"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label=" ">
                        <el-radio-group v-model="queryParams.isLocked">
                            <el-radio :label="0">未锁定</el-radio>
                            <el-radio :label="1">已锁定</el-radio>
                            <el-radio :label="''">全部</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div style="width: 400px;">
                    <el-button  type="primary" @click="getData()" size="small">查询</el-button>
                    <!-- <el-button size="mini" type="success" @click="add">添加</el-button> -->
                    <el-button  type="warning" @click="exportExcel()" size="small">导出excel</el-button>
                </div>
            </div>
        </header>
        <main>
            <el-table stripe ref="report-table" border :header-cell-style="tableHeaderColor" :data="tableData"
                id="export-table" style="width: 100%; color: black;" height="calc(100vh - 190px)" :span-method="mergeTable">
                <el-table-column  type="index" width="50" label="序号" class-name="leave-alone"
                    align="center">
                </el-table-column>
                <af-table-column  prop="shipper"  label="发货人SHIPPER" align="center"> </af-table-column>
                <af-table-column  prop="mblNo"  align="center" label="主单号 MBL"> </af-table-column>
                <af-table-column  prop="containers"   label="箱号 Cont number" align="center"> </af-table-column>
                <af-table-column  prop="hblNo"  label="分单号 HBL" align="center"> </af-table-column>
                <af-table-column  prop="deliveryDate"  label="送达日期 DELIVERY DATE" align="center" width="200"> </af-table-column>
                <af-table-column  prop="goodsName"  label="产品名称 NAME OF CARGO" align="center" width="200"> </af-table-column>
                <af-table-column  prop="date"  label="货物种类 KIND OF CARGO" align="center" width="200"> </af-table-column>
                <af-table-column  prop="date"  label="合同号 CONTRACT NO" align="center"> </af-table-column>
                <af-table-column  prop="tradeType"  label="成交方式 TRADE ITEM" align="center" width="200"> </af-table-column>
                <af-table-column  prop="containerType"  label="箱型量 Cont quantity" align="center" width="200"> </af-table-column>
                <!-- 1 -->
                <af-table-column  prop="date"  label="瓶箱 LCL" align="center"> </af-table-column>
                <af-table-column  prop="ATA"  label=" ATA " align="center"> </af-table-column>
                <af-table-column  prop="ATA"  label=" 提货计划 " align="center"> </af-table-column>

                <el-table-column label="实报实销(应收)" align="center">
                    <af-table-column prop="thc"  label="码头操作费 THC" align="center">
                        <!-- <template slot-scope="scope">{{scope.row.name ? scope.row.name : '--'}}</template> -->
                    </af-table-column>
                    <af-table-column prop="tlx"  label="电放费 TLX" align="center">
                    </af-table-column>
                    <af-table-column prop="mnf"  label="舱单费 MNF" align="center">
                    </af-table-column>
                    <af-table-column prop="lss"  label="低硫附加费 LSS" align="center">
                    </af-table-column>
                    <af-table-column prop="cleanFee"  label="一次洗箱费 Cleaning fee" align="center" width="200">
                    </af-table-column>
                    <af-table-column prop="seal"  label="锁费 SEAL" align="center">
                    </af-table-column>
                    <af-table-column prop="piaoFee"  label=" 票费 " align="center">
                    </af-table-column>
                    <af-table-column prop="emc"  label="设备管理费 EMC" align="center">
                    </af-table-column>
                    <af-table-column prop="cic"  label="箱体不平衡费 CIC" align="center">
                    </af-table-column>
                    <af-table-column prop="cfs"  label=" CFS " align="center">
                    </af-table-column>
                    <af-table-column prop="handingFee"  label="手续费 Handling Fee" align="center" width="200">
                    </af-table-column>
                    <af-table-column prop="liftOn"  label="吊上 LIFT ON" align="center">
                    </af-table-column>
                    <af-table-column prop="liftOff"  label="吊下 LIFT OFF" align="center">
                    </af-table-column>
                </el-table-column>
                <af-table-column prop="truckingFee"  label="拖车费 Trucking fee" align="center" width="200">
                </af-table-column>
                <!-- <af-table-column prop="operationFee" label="操作费operation fee" align="center">
                </af-table-column> -->
                <el-table-column label="实报实销(胡志明段应收)" align="center">
                    <af-table-column prop="saigonFee"  label=" 胡志明基建费 " align="center">
                    </af-table-column>
                    <af-table-column prop="delayFee"  label="压车费 Truck detention" align="center" width="200">
                    </af-table-column>
                    <af-table-column prop="demFee"  label=" DEM " align="center">
                    </af-table-column>
                    <af-table-column prop="detFee"  label=" DET " align="center">
                    </af-table-column>
                    <af-table-column prop="stoFee"  label=" STO " align="center">
                    </af-table-column>
                    <af-table-column prop="repairingFee"  label="修箱费 REPAIRING FEE" align="center" width="200">
                    </af-table-column>
                    <!-- <af-table-column prop="unusualFee" label="异常费用Exceptional Fee" align="center">
                    </af-table-column>
                    <af-table-column prop="unusualFeeNote" label="异常费用原因Cause of Exceptional Fee" align="center">
                    </af-table-column> -->
                </el-table-column>
                <af-table-column prop="customsClearance"  label="清关费(USD) Customs Clearance" align="center" width="240">
                </af-table-column>
                <af-table-column prop="portSurcharge"  label="海关小费 Port Surcharge" align="center" width="200">
                </af-table-column>
                <!-- <af-table-column label="实报实销(VND)" align="center">
                </af-table-column> -->
                <af-table-column prop="exchange"  label=" 汇率 " align="center">
                </af-table-column>
                <af-table-column label="应付费用👉" align="center">
                </af-table-column>
                <el-table-column label="实报实销(应付)" align="center">
                    <af-table-column prop="thcYf"  label="码头操作费 THC" align="center">
                    </af-table-column>
                    <af-table-column prop="tlxYf"  label="电放费 TLX" align="center">
                    </af-table-column>
                    <af-table-column prop="mnfYf"  label="开舱单费 MNF" align="center">
                    </af-table-column>
                    <af-table-column prop="lssYf"  label="低硫附加费 LSS " align="center">
                    </af-table-column>
                    <af-table-column prop="cleanFeeYf"  label="一次洗箱费 Cleaning fee" align="center" width="200">
                    </af-table-column>
                    <af-table-column prop="sealYf"  label="锁费 SEAL" align="center">
                    </af-table-column>
                    <af-table-column prop="piaoFeeYf"  label=" 票费 " align="center">
                    </af-table-column>
                    <af-table-column prop="emcYf"  label="设备管理费 EMC" align="center">
                    </af-table-column>
                    <af-table-column prop="cicYf"  label="箱体不平衡费 CIC" align="center">
                    </af-table-column>
                    <af-table-column prop="cfsYf"  label=" CFS " align="center">
                    </af-table-column>
                    <af-table-column prop="handlingFeeYf"  label="Handling Fee" align="center">
                    </af-table-column>
                    <af-table-column prop="liftOnYf"  label="吊上 LIFT ON" align="center">
                    </af-table-column>
                    <af-table-column prop="liftOffYf"  label="吊下 LIFT OFF" align="center">
                    </af-table-column>
                    <af-table-column prop="extraLoloYf"  label="提柜附加费 EXTRA LOLO" align="center">
                    </af-table-column>
                </el-table-column>
                <af-table-column prop="truckingFeeYf"  label="拖车 Trucking fee" align="center" width="200">
                </af-table-column>
                <!-- <af-table-column prop="unLoadingFee" label="卸货" align="center">
                </af-table-column> -->
                <!-- <af-table-column prop="operationFeeYf" label="操作费" align="center">
                </af-table-column> -->
                <el-table-column label="实报实销(胡志明段应付)" align="center">
                    <af-table-column prop="saigonFeeYf"  label=" 胡志明基建费 " align="center">
                    </af-table-column>
                    <af-table-column prop="delayFeeYf"  label=" 压车费 " align="center">
                    </af-table-column>
                    <af-table-column prop="demFeeYf"  label=" DEM " align="center">
                    </af-table-column>
                    <af-table-column prop="detFeeYf"  label=" DET " align="center">
                    </af-table-column>
                    <af-table-column prop="stoFeeYf"  label=" STO " align="center">
                    </af-table-column>
                    <af-table-column prop="repairingFeeYf"  label="修箱费 REPAIRING FEE" align="center" width="200">
                    </af-table-column>
                    <!-- <af-table-column prop="unusualFeeYf" label="异常费用" align="center">
                    </af-table-column>
                    <af-table-column prop="unusualFeeNote" label="异常费用原因" align="center">
                    </af-table-column> -->
                </el-table-column>
                <af-table-column prop="customsClearanceYf"  label="清关费(USD) Customs Clearance" align="center" width="240">
                </af-table-column>
                <af-table-column prop="portSurchargeYf"  label="海关小费 Port Surcharge" align="center" width="200">
                </af-table-column>
                <!-- <af-table-column label="实报实销(VND)" align="center">
                </af-table-column> -->
                <af-table-column prop="exchange"  label=" 汇率 " align="center">
                </af-table-column>
                <af-table-column prop="incomeVnd" label="应收合计(VND) TOTAL" align="center" width="200">
                    <template slot-scope="scope">
                        <span v-format="'#,##0.00'">{{ scope.row.incomeVnd }}</span>
                    </template>
                </af-table-column>
                <af-table-column prop="incomeUsd" label="应收合计(USD) TOTAL" align="center" width="200">
                    <template slot-scope="scope"  >
                        <span v-format="'#,##0.00'"> {{ scope.row.incomeUsd === null ? '': scope.row.incomeUsd }} </span>
                    </template>
                </af-table-column>
                <af-table-column prop="functionalCurrencyIncome" label="应收合计(折算本位币)" align="center" width="200">
                    <template slot-scope="scope">
                        <span v-format="'#,##0.00'">{{ scope.row.functionalCurrencyIncome }}</span>
                    </template>
                </af-table-column>
                <af-table-column prop="outcomeVnd" label="应付合计(VND) Total" align="center" width="200"> 
                    <template slot-scope="scope">
                        <span v-format="'#,##0.00'">{{ scope.row.outcomeVnd }}</span>
                    </template>
                </af-table-column>
                <af-table-column prop="outcomeUsd" label="应付合计(USD) Total" align="center" width="200">
                    <template slot-scope="scope">
                        <span v-format="'#,##0.00'">{{ scope.row.outcomeUsd }}</span>
                    </template>
                </af-table-column>
                <af-table-column prop="functionalCurrencyOutcome" label="应付合计(折算本位币)" align="center" width="200">
                    <template slot-scope="scope">
                        <span v-format="'#,##0.00'">{{ scope.row.functionalCurrencyOutcome }}</span>
                    </template>
                </af-table-column>
                <af-table-column prop="profitVnd" label="业务毛利(VND)" align="center">
                    <template slot-scope="scope">
                        <span v-format="'#,##0.00'">{{ scope.row.profitVnd }}</span>
                    </template>
                </af-table-column>
                <af-table-column prop="profitUsd" label="业务毛利(USD)" align="center">
                    <template slot-scope="scope">
                        <span v-format="'#,##0.00'">{{ scope.row.profitUsd }}</span>
                    </template>
                </af-table-column>
                <af-table-column prop="functionalCurrencyProfit" label="业务毛利(折算本位币)" align="center" width="200">
                    <template slot-scope="scope">
                        <span v-format="'#,##0.00'">{{ scope.row.functionalCurrencyProfit }}</span>
                    </template>
                </af-table-column>
            </el-table>
        </main>
    </div>
</template>

<script>
import req from '@/utils/index.js';
import url from '@/config/url1.js';
import url1 from '@/config/url2.js';
import ExcelJS from 'exceljs';
// import outputXLSX from '../excel/style';
// "file-saver": "^2.0.2",
// "xlsx": "^0.16.0"
// import FileSaver from 'file-saver'
// import * as XLSX from 'xlsx'
// import * as XLSX_STYLE from 'xlsx-style'
export default {
    name: 'customerReport',
    // mixins: [outputXLSX],
    data() {
        return {
            classOption: [],//货物分类
            customOption: [],//委托单位
            tableData: [],
            formData: [],
            jsonData: {
                "master": [],
                "Table": []
            },
            jsonReport: {},
            queryParams: {
                beginTime: '', //创建时间(开始)
                endTime: '', //创建时间(结束)
                blNo: '', //提单号
                vessel: '',//船名
                customer: '',//委托单位
                category: '',//货物分类
                note: '',//备注
                isLocked: '',//锁定
            },
            // 开始时间限制范围
            startNoTime: {
                disabledDate(date) {
                    // 可选当天以及当天之前的日期
                    return date.getTime() > Date.now()
                }
            },
            // 结束时间限制范围
            endNoTime: {
                disabledDate(date) {
                    // 可选当天以及当天之前的日期
                    return date.getTime() > Date.now()
                }
            },
        }
    },
    watch: {
        "queryParams.beginTime": {
            handler(val) {
                if (val) {
                    this.endNoTime = {
                        disabledDate(time) {
                            const time1 = new Date(val).getTime() - 8.64e7;
                            return time.getTime() < time1 || time.getTime() > Date.now()
                        }
                    }
                } else {
                    // 当清空时，进行一些默认的设置或恢复初始的禁用规则
                    this.endNoTime = {
                        disabledDate(time) {
                            return time.getTime() > Date.now()
                        }
                    }
                }
            }
        },
        "queryParams.endTime": {
            handler(val) {
                if (val) {
                    this.startNoTime = {
                        disabledDate(time) {
                            const time1 = new Date(val).getTime()
                            return time.getTime() > time1 || time.getTime() > Date.now()
                        }
                    }
                } else {
                    this.startNoTime = {
                        disabledDate(time) {
                            return time.getTime() > Date.now()
                        }
                    }
                }
            }
        },

    },
    mounted() {
        this.getLabelArray();
        // this.getData();
    },
    created() {
        this.getClassOption();
        this.getcustomList();
        // this.getData()
    },
    methods: {
        getLabelArray() {
            const tableRef = this.$refs['report-table'];

        },
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0 && columnIndex >= 0 && columnIndex < 14) {
                return 'background-color: #fbe3d6; color:#252525;'; //粉色
            } else if ((rowIndex === 0 && columnIndex >= 14 && columnIndex <= 19 ) || (rowIndex === 0 && columnIndex >= 27 && columnIndex <= 29 )) {
                return 'background-color: #ffe598; color:#252525;'; //黄色
            } else if ((rowIndex === 1) || (rowIndex === 0 && columnIndex >= 33 && columnIndex <= 35) ) {
                return 'background-color: #e2f0d9; color:#252525;';//绿色
            } else if ((rowIndex === 0 && columnIndex >= 20 && columnIndex <= 26) || (rowIndex === 0 && columnIndex >= 30 && columnIndex <= 32)) {
                return 'background-color: #bdd5ed; color:#252525;';//蓝底 
            } else {
                return 'color:#252525; background: #ffffff;';
            }
        },
        // exportExcel(excelName) {
        //     try {
        //         const $e = this.$refs['report-table'].$el
        //         let $table = $e.querySelector('.el-table__fixed')
        //         if (!$table) {
        //             $table = $e
        //         }

        //         const wb = XLSX.utils.table_to_book($table, { raw: true })
        //         const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
        //         FileSaver.saveAs(
        //             new Blob([wbout], { type: 'application/octet-stream' }),
        //             `${excelName}.xlsx`,
        //         )
        //     } catch (e) {
        //         if (typeof console !== 'undefined') console.error(e)
        //     }
        // },
        async exportExcel() {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');

            // 设置表头样式
            const headerStyle = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center'
                },
                border: {
                    top: { style: 'thin', color: 'black' },
                    bottom: { style: 'thin', color: 'black' },
                    left: { style: 'thin', color: 'black' },
                    right: { style: 'thin', color: 'black' }
                }
            };

            // 设置普通单元格样式
            const cellStyle = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center'
                },
                border: {
                    top: { style: 'thin', color: 'black' },
                    bottom: { style: 'thin', color: 'black' },
                    left: { style: 'thin', color: 'black' },
                    right: { style: 'thin', color: 'black' }
                }
            };
            const $table = this.$refs['report-table'].$el;
            const firstHeader = [];
            const secondHeader = [];
            const beforeSecond = [];
            const headerRows = $table.querySelectorAll('.el-table__header-wrapper > table > thead > tr');

            headerRows.forEach((headerRow, index) => {
                const cells = headerRow.querySelectorAll('th');
                if (index === 0) {
                    // 第一层表头
                    cells.forEach((cell) => {
                        const colspan = parseInt(cell.getAttribute('colspan')) || 1;
                        const cellText = cell.textContent;
                        if (colspan === 1) {
                            firstHeader.push(cellText);
                            // 将第二层对应位置的表头置为空字符串
                            if (secondHeader.length < firstHeader.length) {
                                secondHeader.push('');
                            }
                        } else {
                            for (let i = 0; i < colspan; i++) {
                                firstHeader.push(cellText);
                            }
                        }
                    });
                } else {
                    // 第二层表头
                    // 先拿到第二层所有的数据
                    const cells = headerRow.querySelectorAll('th');
                    cells.forEach((cell) => {
                        const cellText = cell.textContent;
                        beforeSecond.push(cellText);
                    });
                }
            });

            // 将处理好的firstHeader和secondHeader组合成类似示例的headers格式    
            for (let i = 0; i < firstHeader.length - 1; i++) {
                if (i < firstHeader.length && firstHeader[i] === firstHeader[i - 1]) {
                    const valueToMove = beforeSecond.shift();
                    secondHeader[i - 1] = valueToMove;
                } else if (i < firstHeader.length && i > 0 && firstHeader[i] !== firstHeader[i - 1] && firstHeader[i - 1] === firstHeader[i - 2]) {
                    const valueToMove = beforeSecond.shift();
                    secondHeader[i - 1] = valueToMove;

                } else {
                    secondHeader[i - 1] = '';
                }
            }
            firstHeader.pop();
            // secondHeader.splice(-1, 1);
            let dataToProcess;
            dataToProcess = Object.values(secondHeader);
            const headers = [firstHeader, dataToProcess];

            // 两层表头写入excel
            // 两层表头写入excel
            for (let i = 1; i <= headers.length; i++) {
                const row = worksheet.addRow(headers[i - 1]);
                // 遍历当前行的每个单元格并应用表头样式
                row.eachCell((cell) => {
                    cell.border = headerStyle.border;
                    cell.alignment = headerStyle.alignment;
                });
            }
            worksheet.getCell('AQ1').fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFF00' }
            };
            // for (let i = 1; i <= widthList.length; i++) {
            //     worksheet.getColumn(i).width = widthList[i - 1];
            // }
            const colNames = [
                "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
                "AA", "AB", "AC", "AD", "AE", "AF", "AG", "AH", "AI", "AJ", "AK", "AL", "AM", "AN", "AO", "AP", "AQ", "AR", "AS", "AT", "AU", "AV", "AW", "AX", "AY", "AZ",
                "BA", "BB", "BC", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BK", "BL", "BM", "BN", "BO", "BP", "BQ", "BR", "BS", "BT", "BU", "BV", "BW", "BX", "BY", "BZ",
                "CA", "CB", "CC", "CD", "CE", "CF", "CG", "CH", "CI", "CJ", "CK", "CL", "CM", "CN", "CO", "CP", "CQ", "BR", "BS", "BT", "BU", "BV", "BW", "BX", "BY", "BZ",
                "DA", "DB", "DC", "DD", "DE", "DF", "DG", "DH", "DI", "DJ", "DK", "DL", "DM", "DN", "DO", "DP", "DQ", "DR", "DS", "DT", "DU", "DV", "DW", "DX", "DY", "DZ",
                "EA", "EB", "EC", "ED", "EE", "EF", "EG", "EH", "EI", "EJ", "EK", "EL", "EM", "EN", "EO", "EP", "EQ", "ER", "ES", "ET", "EU", "EV", "EW", "EX", "EY", "EZ",
                "FA", "FB", "FC", "FD", "FE", "FF", "FG", "FH", "FI", "FJ", "FK", "FL", "FM", "FN", "FO", "FP", "FQ", "FR", "FS", "FT", "FU", "FV", "FW", "FX", "FY", "FZ",
                "GA", "GB", "GC", "GD", "GE", "GF", "GG", "GH", "GI", "GJ", "GK", "GL", "GM", "GN", "GO", "GP", "GQ", "GR", "GS", "GT", "GU", "GV", "GW", "GX", "GY", "GZ",
                "HA", "HB", "HC", "HD", "HE", "HF", "HG", "HH", "HI", "HJ", "HK", "HL", "GM", "GN", "GO", "GP", "GQ", "GR", "GS", "GT", "GU", "GV", "GW", "GX", "GY", "GZ",
                "IA", "IB", "IC", "ID", "IE", "IF", "IG", "IH", "II", "IJ", "IK", "IL", "IM", "IN", "IO", "IP", "IQ", "IR", "IS", "IT", "IU", "IV", "IW", "IX", "IY", "IZ",
                "JA", "JB", "JC", "JD", "JE", "JF", "JG", "JH", "JI", "JJ", "JK", "JL", "JM", "JN", "JO", "JP", "JQ", "JR", "JS", "JT", "JU", "JV", "JW", "JX", "JY", "JZ",
                "KA", "KB", "KC", "KD", "KE", "KF", "KG", "KH", "KI", "KJ", "KK", "KL", "KM", "KN", "KO", "KP", "KQ", "KR", "KS", "KT", "KU", "KV", "KW", "KX", "KY", "KZ",
                "LA", "LB", "LC", "LD", "LE", "LF", "LG", "LH", "LI", "LJ", "LK", "LL", "LM", "LN", "LO", "LP", "LQ", "LR", "LS", "LT", "LU", "LV", "LW", "LX", "LY", "LZ",
                "MA", "MB", "MC", "MD", "ME", "MF", "MG", "MH", "MI", "MJ", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ",
                "NA", "NB", "NC", "ND", "ME", "MF", "MG", "MH", "MI", "MJ", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ",
                "OA", "OB", "OC", "OD", "OE", "OF", "OG", "OH", "OI", "OJ", "OK", "OL", "OM", "ON", "OO", "OP", "OQ", "OR", "OS", "OT", "OU", "OV", "OW", "OX", "OY", "OZ",
                "PA", "PB", "PC", "PD", "PE", "PF", "PG", "PH", "PI", "PJ", "PK", "PL", "PM", "PN", "PO", "PP", "PQ", "PR", "PS", "PT", "PU", "PV", "PW", "PX", "PY", "PZ",
                "QA", "QB", "QC", "QD", "QE", "QF", "QG", "QH", "QI", "QJ", "QK", "QL", "QM", "QN", "QO", "QP", "QQ", "QR", "QS", "QT", "QU", "QV", "QW", "QX", "QY", "QZ",
                "RA", "RB", "RC", "RD", "RE", "RF", "RG", "RH", "RI", "RJ", "RK", "RL", "RM", "RN", "RO", "RP", "RQ", "RR", "RS", "RT", "RU", "RV", "RW", "RX", "RY", "RZ",
                "SA", "SB", "SC", "SD", "SE", "SF", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SP", "SQ", "SR", "SS", "ST", "SU", "SV", "SW", "SX", "SY", "SZ",
                "TA", "TB", "TC", "TD", "TE", "TF", "TG", "TH", "TI", "TJ", "SK", "SL", "SM", "SN", "SO", "SP", "SQ", "SR", "SS", "ST", "SU", "SV", "SW", "SX", "SY", "SZ",
                "UA", "UB", "UC", "UD", "UE", "UF", "UG", "UH", "UI", "UJ", "UK", "UL", "UM", "UN", "UO", "UP", "UQ", "UR", "US", "UT", "UU", "UV", "UW", "UX", "UY", "UZ",
                "VA", "VB", "VC", "VD", "VE", "VF", "VG", "VH", "VI", "VJ", "VK", "VL", "VM", "VN", "VO", "VP", "VQ", "VR", "VS", "VT", "VU", "VV", "VW", "VX", "VY", "VZ",
                "WA", "WB", "WC", "WD", "WE", "WF", "WG", "WH", "WI", "WJ", "WK", "VL", "VM", "VN", "VO", "VP", "VQ", "VR", "VS", "VT", "VU", "VV", "VW", "VX", "VY", "VZ",
                "XA", "XB", "XC", "XD", "XE", "XF", "XG", "XH", "XI", "XJ", "XK", "XL", "XM", "XN", "XO", "XP", "XQ", "XR", "XS", "XT", "XU", "XV", "XW", "XX", "XY", "XZ",
                "YA", "YB", "YC", "YD", "YE", "XF", "XG", "XH", "XI", "XJ", "XK", "XL", "XM", "XN", "XO", "XP", "XQ", "XR", "XS", "XT", "XU", "XV", "XW", "XX", "XY", "XZ",
                "ZA", "ZB", "ZC", "ZD", "ZE", "ZF", "ZG", "ZH", "ZI", "ZJ", "ZK", "ZL", "ZM", "ZN", "ZO", "ZP", "ZQ", "ZR", "ZS", "ZT", "ZU", "ZV", "ZW", "ZX", "ZY", "ZZ"];
            const getDataType = function (val) {
                return Object.prototype.toString
                    .call(val)
                    .replace(/^\[object (\S+)\]$/, "$1")
                    .toLowerCase();
            };
            const emptyCheck = function (val) {
                if (val === null || val === "" || val === undefined) {
                    return false;
                }
                let dataType = getDataType(val);
                switch (dataType) {
                    case "string":
                        return val.trim().length !== 0;
                    case "array":
                        return val.length !== 0;
                    case "object":
                        return Object.keys(val).length !== 0;
                }
                return true;
            };
            // 对比headers[0]和headers[1]，根据条件横向合并单元格
            for (let i = 0; i < headers.length; i++) {
                let arr = [null, null];
                for (let j = 1; j <= headers[i].length; j++) {
                    if (headers[i][j - 1] === headers[i][j]) {    // 前后元素相同，表示可以合并
                        if (!emptyCheck(arr[0]) && emptyCheck(headers[i][j - 1])) {
                            arr[0] = colNames[j - 1] + (i + 1);
                        }
                        arr[1] = colNames[j] + (i + 1);
                    } else {    // 前后元素不相同，j是从1开始，所以表示没有相同列或者此次相同列已结束
                        if (emptyCheck(arr[0]) && emptyCheck(arr[1])) {
                            // arr[0]或者arr[1]为空，表示相邻元素不同，均有值表示有相同列，arr[1]便是最后一个相同的列
                            worksheet.mergeCells(arr[0] + ":" + arr[1]);
                        }
                        arr = [null, null];    // 相邻元素不同，arr重置，准备下一批可合并元素
                    }
                }
            }
            // 对比headers[0]和headers[1]，根据条件纵向合并单元格
            let col = headers[0];
            // 第一层循环具体元素
            for (let i = 0; i < col.length; i++) {
                let sd = ""; // 开始元素
                let ed = ""; // 结束元素
                // 第二层循环，比较层级不同下标相同的元素
                for (let j = 1; j < headers.length; j++) {
                    if (headers[j][i] === "") {  // 元素为空，表示可与上层元素合并
                        sd = emptyCheck(sd) ? sd : colNames[i] + j;
                        ed = colNames[i] + (j + 1);
                    }
                }
                //合并并且再次垂直居中
                if (emptyCheck(sd) && emptyCheck(ed)) {
                    worksheet.mergeCells(sd + ":" + ed);

                }
            }
            const elTablerow = [];
            const dataRows = $table.querySelectorAll('.el-table__body-wrapper >.el-table__body > tbody >.el-table__row');
            dataRows.forEach((dataRow) => {
                const rowData = [];
                const cells = dataRow.querySelectorAll('td > div');

                cells.forEach((cell) => {
                    const cellText = cell.textContent;
                    rowData.push(cellText);
                });

                elTablerow.push(rowData);
            });
            var  mergeStartRow_S = 3; // 数据从第3行开始（表头在第1,2行）,合并起始行
            var  mergeStartRow_E = 3; // 数据从第3行开始（表头在第1,2行）,合并结束行
            const tableData = elTablerow; // 这里需要根据你的实际情况获取表格数据
            tableData.forEach((rowData,index) => {
                const row = worksheet.addRow(rowData);
                row.eachCell((cell) => {
                    cell.border = cellStyle.border;
                    cell.alignment = cellStyle.alignment;
                });
                // 合并列
                if(index > 0){
                    if(this.tableData[index].id === this.tableData[index-1].id){ // 相同结束行+1
                        mergeStartRow_E++;
                    }else{
                        if(mergeStartRow_S === mergeStartRow_E) {// id不相同,判断起始结束行是否一致
                            mergeStartRow_S++;
                            mergeStartRow_E++;
                        }else{ // id不相同且起始结束行不一致,合并且重置起始结束行
                            worksheet.mergeCells(`BM${mergeStartRow_S}:BM${mergeStartRow_E}`);
                            worksheet.mergeCells(`BN${mergeStartRow_S}:BN${mergeStartRow_E}`);
                            worksheet.mergeCells(`BO${mergeStartRow_S}:BO${mergeStartRow_E}`);
                            worksheet.mergeCells(`BP${mergeStartRow_S}:BP${mergeStartRow_E}`);
                            worksheet.mergeCells(`AL${mergeStartRow_S}:AL${mergeStartRow_E}`);
                            worksheet.mergeCells(`AM${mergeStartRow_S}:AM${mergeStartRow_E}`);
                            mergeStartRow_S = index+3;
                            mergeStartRow_E = index+3;
                        }
                    }
                }
                // 判断是不是最后一条
                if(index>0 && index === this.tableData.length-1){
                    // 最后一条,起始结束行不一致,不做操作
                    if(mergeStartRow_S !== mergeStartRow_E){
                        worksheet.mergeCells(`BM${mergeStartRow_S}:BM${mergeStartRow_E}`);
                        worksheet.mergeCells(`BN${mergeStartRow_S}:BN${mergeStartRow_E}`);
                        worksheet.mergeCells(`BO${mergeStartRow_S}:BO${mergeStartRow_E}`);
                        worksheet.mergeCells(`BP${mergeStartRow_S}:BP${mergeStartRow_E}`);
                        worksheet.mergeCells(`AL${mergeStartRow_S}:AL${mergeStartRow_E}`);
                        worksheet.mergeCells(`AM${mergeStartRow_S}:AM${mergeStartRow_E}`);
                    }
                }
            });
            // 设置列宽（根据需要调整列宽值）
            worksheet.columns.forEach((column, index) => {
                column.width = 17;
                column.alignment = { vertical: 'middle', horizontal: 'center' };

            });
            // 生成Excel文件并提供下载
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.getFormattedDateTime()}`;
            link.click();
            window.URL.revokeObjectURL(url);
        },
        getFormattedDateTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
        },
        getData() {

            let URL = `${url.incomeAndpayReport}`;

            req.post(URL, this.queryParams)
                .then(res => {
                    // 获取到的原始数据
                    this.tableData = res.data.data;
                    // 将处理后的数据赋值给表格数据来源
                    // 数据加载完成后，候Vue的下一个DOM更新周期，确保表格相关的DOM更新完成
                    return this.$nextTick();
                });
            // 其他方法定义，如preprocessData等

        },
        // 获取货物分类数据
        getClassOption() {
            let value = '货物分类';
            let URL = `${url.getDicList}/?value=${value}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.classOption = res.data.data.data;
                }
            })
        },
        //获取委托单位数据
        getcustomList() {
            let URL = `${url1.getList}/?name=${this.queryParams.customer}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.customOption = res.data.data;
                }
            })
        },
        // 合并单元格
        mergeTable({ row, column, rowIndex, columnIndex }){ // 行,列,行索引,列索引
            if(column.label === '应收合计(VND) TOTAL' || column.label === '应收合计(USD) TOTAL' || column.label === '应付合计(VND) Total' 
            || column.label === '应付合计(USD) Total' || column.label === '业务毛利(VND)' || column.label === '业务毛利(USD)' || column.label === '应收合计(折算本位币)'
            || column.label === '应付合计(折算本位币)' || column.label === '业务毛利(折算本位币)'){
                // 获取当前单元格的id
                const currentID = row['id']
                // 获取上一行相同列的值
                const preRow = this.tableData[rowIndex - 1]
                const preID = preRow ? preRow['id'] : null
                if (currentID === preID ) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                } else{
                    // 否则计算当前单元格应该跨越多少行
                    let rowspan = 1
                    for (let i = rowIndex + 1; i < this.tableData.length; i++) {
                        const nextRow = this.tableData[i]
                        const nextid = nextRow['id']
                        if (nextid === currentID) {
                            rowspan++
                        } else {
                            break
                        }
                    }
                    return {
                        rowspan,
                        colspan: 1
                    }
                }
            }
        },
    },

}
</script>

<style lang="css" scoped>
::v-deep .el-table td,
::v-deep .el-table th {
    border-color: #979595 !important;
}

::v-deep .el-table th.gutter {
    display: table-cell !important;
}

.el-table {
    border-color: #979595 !important;
}

.el-table {
    table-layout: auto;
}

::v-deep .el-table .el-table__cell {
    padding: 0px 0;
}

.el-form-item {
    margin-bottom: 0;
}

::v-deep .el-form-item__label {
    white-space: nowrap;
}

::v-deep .cell {
    /* white-space: nowrap; */
    word-break: keep-all;
    overflow: visible;
    width: 100%;
}
</style>